import styled from '@emotion/styled';
import { forPhoneOnly, Variables } from '../../base';

interface IEntry {
    note?: boolean;
    aiNote?: boolean;
}

export const History = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
`;

export const CommentsHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 32px;
    border-top: 1px solid ${Variables.Colors.n15};
`;

export const CommentsContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const CommentsIcon = styled.div`
    display: flex;
    align-items: center;
    color: ${Variables.Colors.n85};
`;

export const CommentsLabel = styled.div`
    font-size: 14px;
    font-weight: ${Variables.FontWeight.semibold};
    color: ${Variables.Colors.n85};
`;

export const UpdatedByText = styled.div`
    font-size: 14px;
    font-weight: ${Variables.FontWeight.regular};
    color: ${Variables.Colors.n85};
`;

export const HistoryHeader = styled.div`
    display: flex;
    align-items: center;
    padding: 0px 16px;
`;

export const HistoryHeaderLine = styled.div`
    flex-grow: 1;
    box-shadow: ${Variables.Shadows.border};
`;

export const HistoryHeaderLabel = styled.div`
    font-size: 15px;
    letter-spacing: 0.4px;
    color: ${Variables.Colors.n70};
    padding: 0 24px;
`;

export const HistoryBody = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    gap: 16px;
    padding: 0px 24px 16px 24px;
    margin: 0px 0px 25px;
`;

const EntryComment = `
    padding: 8px;
    color: ${Variables.Colors.n100};
    background-color: transparent;
    border: none;
`;
const EntryNote = `
    padding: 8px;
    border: none;
    background: linear-gradient(180deg, ${Variables.ThemeLight.NeutralMild2} 0%, ${Variables.ThemeLight.Background2} 100%);
    border-radius: ${Variables.Rounded.large};
`;
const EntryAINote = `
    padding: 8px;
    border: none;
    background: linear-gradient(180deg, ${Variables.ThemeLight.PrimaryMild2} 0%, ${Variables.ThemeLight.Background2} 100%);
    border-radius: ${Variables.Rounded.large};
`;

export const HistoryEntry = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 0;
    font-size: 14px;
    letter-spacing: 0;

    ${(props: IEntry): string | undefined => (props.aiNote ? EntryAINote : props.note ? EntryNote : EntryComment)}

    ${forPhoneOnly(`
        display: block;
    `)};
`;

export const HistoryEntryHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
`;

export const HistoryEntryName = styled.div`
    font-size: 14px;
    font-weight: ${Variables.FontWeight.semibold};
    color: ${Variables.Colors.n100};
`;

export const HistoryEntryTime = styled.div`
    font-size: 14px;
    font-weight: ${Variables.FontWeight.regular};
    color: ${Variables.Colors.n70};
`;

export const HistoryNoteIndicator = styled.div`
    margin-left: auto;
`;

export const HistoryEntryMessage = styled.div`
    display: block;
    padding: 0;
    margin-left: 32px;
    line-height: 1.5;
    color: ${Variables.Colors.n100};

    overflow-x: hidden;

    * {
        white-space: pre-wrap;
        max-width: 100%;
    }

    pre,
    code {
        word-wrap: break-word;
        overflow-wrap: break-word;
    }
`;

export const HistoryEntryAttachment = styled.div`
    padding: 8px 0;
`;

export const LoadingText = styled.div`
    font-size: 14px;
    color: ${Variables.Colors.n50};
    font-style: italic;
    padding: 8px 0;
`;
